/* eslint-disable */
// @ts-nocheck
import * as Types from '../schema/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type GetUserFoldersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserFoldersQuery = { __typename?: 'Query', user: { __typename?: 'UserType', id: number, folders: Array<{ __typename?: 'FolderType', id: number, name: string, parentFolderId?: number | null, isShared: boolean, userOwnerId: number, userOwnerEmail: string, qrCount: number, sharedUsers: Array<{ __typename?: 'FolderSharedUserType', id: number, userId: number, username: string, role: Types.GqlSharedUserRole, status: Types.GqlShareFolderStatus }>, subfolders: Array<{ __typename?: 'FolderType', id: number, name: string, parentFolderId?: number | null, isShared: boolean, userOwnerId: number, userOwnerEmail: string, qrCount: number, sharedUsers: Array<{ __typename?: 'FolderSharedUserType', id: number, userId: number, username: string, role: Types.GqlSharedUserRole, status: Types.GqlShareFolderStatus }> }> }> } };

export type ShareFolderMutationVariables = Types.Exact<{
  input: Types.ShareFolderInput;
}>;


export type ShareFolderMutation = { __typename?: 'Mutation', shareFolder: boolean };

export type DeleteFolderMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteFolderMutation = { __typename?: 'Mutation', deleteFolder: boolean };

export type CreateSubfolderMutationVariables = Types.Exact<{
  input: Types.CreateSubfolderInput;
}>;


export type CreateSubfolderMutation = { __typename?: 'Mutation', createSubfolder: boolean };

export type ChangeFolderOwnerMutationVariables = Types.Exact<{
  folderId: Types.Scalars['Int']['input'];
  email: Types.Scalars['String']['input'];
}>;


export type ChangeFolderOwnerMutation = { __typename?: 'Mutation', changeFolderOwner: boolean };

export type RenameFolderMutationVariables = Types.Exact<{
  input: Types.FolderUpdateInput;
}>;


export type RenameFolderMutation = { __typename?: 'Mutation', editFolder: boolean };

export type CreateFolderMutationVariables = Types.Exact<{
  input: Types.FolderCreateInput;
}>;


export type CreateFolderMutation = { __typename?: 'Mutation', createFolder: { __typename?: 'FolderType', id: number } };

export type MoveFolderMutationVariables = Types.Exact<{
  parentId: Types.Scalars['Int']['input'];
  childrenId: Types.Scalars['Int']['input'];
}>;


export type MoveFolderMutation = { __typename?: 'Mutation', moveFolder: boolean };

export type RespondToChangeFolderOwnerMutationVariables = Types.Exact<{
  requestId: Types.Scalars['Int']['input'];
  isAccept: Types.Scalars['Boolean']['input'];
}>;


export type RespondToChangeFolderOwnerMutation = { __typename?: 'Mutation', respondToChangeFolderOwner: boolean };

export type RespondToFolderShareMutationVariables = Types.Exact<{
  requestId: Types.Scalars['Int']['input'];
  isAccept: Types.Scalars['Boolean']['input'];
}>;


export type RespondToFolderShareMutation = { __typename?: 'Mutation', respondToFolderShare: boolean };

export type DownloadFolderQrZipMutationVariables = Types.Exact<{
  folderId: Types.Scalars['Int']['input'];
  extension: Types.Scalars['String']['input'];
  size: Types.Scalars['Int']['input'];
}>;


export type DownloadFolderQrZipMutation = { __typename?: 'Mutation', downloadFolderQrZip: { __typename?: 'FolderZipOutput', status?: Types.GqlFolderReportStatus | null, url?: string | null } };

export type FolderZipReportQueryVariables = Types.Exact<{
  folderId: Types.Scalars['Int']['input'];
}>;


export type FolderZipReportQuery = { __typename?: 'Query', folderZipReport?: { __typename?: 'FolderZipOutput', status?: Types.GqlFolderReportStatus | null, url?: string | null, extension?: string | null, size?: number | null } | null };

export type GenerateOrGetFolderReportMutationVariables = Types.Exact<{
  folderId: Types.Scalars['Int']['input'];
}>;


export type GenerateOrGetFolderReportMutation = { __typename?: 'Mutation', generateOrGetFolderReport: { __typename?: 'FolderReportOutput', status: string, reportKey: string, downloadUrl?: string | null, message?: string | null } };

export type RevokePermissionMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  status: Types.GqlShareFolderStatus;
}>;


export type RevokePermissionMutation = { __typename?: 'Mutation', revokePermission: boolean };

export type MarkFolderReportDownloadedMutationVariables = Types.Exact<{
  folderId: Types.Scalars['Int']['input'];
}>;


export type MarkFolderReportDownloadedMutation = { __typename?: 'Mutation', markFolderReportDownloaded: boolean };


export const GetUserFoldersDocument = gql`
    query GetUserFolders {
  user {
    id
    folders {
      id
      name
      parentFolderId
      isShared
      userOwnerId
      userOwnerEmail
      qrCount
      sharedUsers {
        id
        userId
        username
        role
        status
      }
      subfolders {
        id
        name
        parentFolderId
        isShared
        userOwnerId
        userOwnerEmail
        qrCount
        sharedUsers {
          id
          userId
          username
          role
          status
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserFoldersQuery__
 *
 * To run a query within a React component, call `useGetUserFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFoldersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserFoldersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserFoldersQuery, GetUserFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserFoldersQuery, GetUserFoldersQueryVariables>(GetUserFoldersDocument, options);
      }
export function useGetUserFoldersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserFoldersQuery, GetUserFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserFoldersQuery, GetUserFoldersQueryVariables>(GetUserFoldersDocument, options);
        }
// @ts-ignore
export function useGetUserFoldersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserFoldersQuery, GetUserFoldersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserFoldersQuery, GetUserFoldersQueryVariables>;
export function useGetUserFoldersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserFoldersQuery, GetUserFoldersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserFoldersQuery | undefined, GetUserFoldersQueryVariables>;
export function useGetUserFoldersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserFoldersQuery, GetUserFoldersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserFoldersQuery, GetUserFoldersQueryVariables>(GetUserFoldersDocument, options);
        }
export type GetUserFoldersQueryHookResult = ReturnType<typeof useGetUserFoldersQuery>;
export type GetUserFoldersLazyQueryHookResult = ReturnType<typeof useGetUserFoldersLazyQuery>;
export type GetUserFoldersSuspenseQueryHookResult = ReturnType<typeof useGetUserFoldersSuspenseQuery>;
export type GetUserFoldersQueryResult = ApolloReactCommon.QueryResult<GetUserFoldersQuery, GetUserFoldersQueryVariables>;
export const ShareFolderDocument = gql`
    mutation ShareFolder($input: ShareFolderInput!) {
  shareFolder(input: $input)
}
    `;
export type ShareFolderMutationFn = ApolloReactCommon.MutationFunction<ShareFolderMutation, ShareFolderMutationVariables>;

/**
 * __useShareFolderMutation__
 *
 * To run a mutation, you first call `useShareFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareFolderMutation, { data, loading, error }] = useShareFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareFolderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShareFolderMutation, ShareFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShareFolderMutation, ShareFolderMutationVariables>(ShareFolderDocument, options);
      }
export type ShareFolderMutationHookResult = ReturnType<typeof useShareFolderMutation>;
export type ShareFolderMutationResult = ApolloReactCommon.MutationResult<ShareFolderMutation>;
export type ShareFolderMutationOptions = ApolloReactCommon.BaseMutationOptions<ShareFolderMutation, ShareFolderMutationVariables>;
export const DeleteFolderDocument = gql`
    mutation DeleteFolder($id: Int!) {
  deleteFolder(id: $id)
}
    `;
export type DeleteFolderMutationFn = ApolloReactCommon.MutationFunction<DeleteFolderMutation, DeleteFolderMutationVariables>;

/**
 * __useDeleteFolderMutation__
 *
 * To run a mutation, you first call `useDeleteFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderMutation, { data, loading, error }] = useDeleteFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFolderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFolderMutation, DeleteFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFolderMutation, DeleteFolderMutationVariables>(DeleteFolderDocument, options);
      }
export type DeleteFolderMutationHookResult = ReturnType<typeof useDeleteFolderMutation>;
export type DeleteFolderMutationResult = ApolloReactCommon.MutationResult<DeleteFolderMutation>;
export type DeleteFolderMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFolderMutation, DeleteFolderMutationVariables>;
export const CreateSubfolderDocument = gql`
    mutation CreateSubfolder($input: CreateSubfolderInput!) {
  createSubfolder(input: $input)
}
    `;
export type CreateSubfolderMutationFn = ApolloReactCommon.MutationFunction<CreateSubfolderMutation, CreateSubfolderMutationVariables>;

/**
 * __useCreateSubfolderMutation__
 *
 * To run a mutation, you first call `useCreateSubfolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubfolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubfolderMutation, { data, loading, error }] = useCreateSubfolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubfolderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSubfolderMutation, CreateSubfolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSubfolderMutation, CreateSubfolderMutationVariables>(CreateSubfolderDocument, options);
      }
export type CreateSubfolderMutationHookResult = ReturnType<typeof useCreateSubfolderMutation>;
export type CreateSubfolderMutationResult = ApolloReactCommon.MutationResult<CreateSubfolderMutation>;
export type CreateSubfolderMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSubfolderMutation, CreateSubfolderMutationVariables>;
export const ChangeFolderOwnerDocument = gql`
    mutation ChangeFolderOwner($folderId: Int!, $email: String!) {
  changeFolderOwner(folderId: $folderId, email: $email)
}
    `;
export type ChangeFolderOwnerMutationFn = ApolloReactCommon.MutationFunction<ChangeFolderOwnerMutation, ChangeFolderOwnerMutationVariables>;

/**
 * __useChangeFolderOwnerMutation__
 *
 * To run a mutation, you first call `useChangeFolderOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeFolderOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeFolderOwnerMutation, { data, loading, error }] = useChangeFolderOwnerMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useChangeFolderOwnerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeFolderOwnerMutation, ChangeFolderOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeFolderOwnerMutation, ChangeFolderOwnerMutationVariables>(ChangeFolderOwnerDocument, options);
      }
export type ChangeFolderOwnerMutationHookResult = ReturnType<typeof useChangeFolderOwnerMutation>;
export type ChangeFolderOwnerMutationResult = ApolloReactCommon.MutationResult<ChangeFolderOwnerMutation>;
export type ChangeFolderOwnerMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeFolderOwnerMutation, ChangeFolderOwnerMutationVariables>;
export const RenameFolderDocument = gql`
    mutation RenameFolder($input: FolderUpdateInput!) {
  editFolder(input: $input)
}
    `;
export type RenameFolderMutationFn = ApolloReactCommon.MutationFunction<RenameFolderMutation, RenameFolderMutationVariables>;

/**
 * __useRenameFolderMutation__
 *
 * To run a mutation, you first call `useRenameFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameFolderMutation, { data, loading, error }] = useRenameFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameFolderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RenameFolderMutation, RenameFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RenameFolderMutation, RenameFolderMutationVariables>(RenameFolderDocument, options);
      }
export type RenameFolderMutationHookResult = ReturnType<typeof useRenameFolderMutation>;
export type RenameFolderMutationResult = ApolloReactCommon.MutationResult<RenameFolderMutation>;
export type RenameFolderMutationOptions = ApolloReactCommon.BaseMutationOptions<RenameFolderMutation, RenameFolderMutationVariables>;
export const CreateFolderDocument = gql`
    mutation CreateFolder($input: FolderCreateInput!) {
  createFolder(input: $input) {
    id
  }
}
    `;
export type CreateFolderMutationFn = ApolloReactCommon.MutationFunction<CreateFolderMutation, CreateFolderMutationVariables>;

/**
 * __useCreateFolderMutation__
 *
 * To run a mutation, you first call `useCreateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFolderMutation, { data, loading, error }] = useCreateFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFolderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFolderMutation, CreateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFolderMutation, CreateFolderMutationVariables>(CreateFolderDocument, options);
      }
export type CreateFolderMutationHookResult = ReturnType<typeof useCreateFolderMutation>;
export type CreateFolderMutationResult = ApolloReactCommon.MutationResult<CreateFolderMutation>;
export type CreateFolderMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateFolderMutation, CreateFolderMutationVariables>;
export const MoveFolderDocument = gql`
    mutation MoveFolder($parentId: Int!, $childrenId: Int!) {
  moveFolder(parentId: $parentId, childrenId: $childrenId)
}
    `;
export type MoveFolderMutationFn = ApolloReactCommon.MutationFunction<MoveFolderMutation, MoveFolderMutationVariables>;

/**
 * __useMoveFolderMutation__
 *
 * To run a mutation, you first call `useMoveFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFolderMutation, { data, loading, error }] = useMoveFolderMutation({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      childrenId: // value for 'childrenId'
 *   },
 * });
 */
export function useMoveFolderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveFolderMutation, MoveFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveFolderMutation, MoveFolderMutationVariables>(MoveFolderDocument, options);
      }
export type MoveFolderMutationHookResult = ReturnType<typeof useMoveFolderMutation>;
export type MoveFolderMutationResult = ApolloReactCommon.MutationResult<MoveFolderMutation>;
export type MoveFolderMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveFolderMutation, MoveFolderMutationVariables>;
export const RespondToChangeFolderOwnerDocument = gql`
    mutation RespondToChangeFolderOwner($requestId: Int!, $isAccept: Boolean!) {
  respondToChangeFolderOwner(requestId: $requestId, isAccept: $isAccept)
}
    `;
export type RespondToChangeFolderOwnerMutationFn = ApolloReactCommon.MutationFunction<RespondToChangeFolderOwnerMutation, RespondToChangeFolderOwnerMutationVariables>;

/**
 * __useRespondToChangeFolderOwnerMutation__
 *
 * To run a mutation, you first call `useRespondToChangeFolderOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToChangeFolderOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToChangeFolderOwnerMutation, { data, loading, error }] = useRespondToChangeFolderOwnerMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      isAccept: // value for 'isAccept'
 *   },
 * });
 */
export function useRespondToChangeFolderOwnerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RespondToChangeFolderOwnerMutation, RespondToChangeFolderOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RespondToChangeFolderOwnerMutation, RespondToChangeFolderOwnerMutationVariables>(RespondToChangeFolderOwnerDocument, options);
      }
export type RespondToChangeFolderOwnerMutationHookResult = ReturnType<typeof useRespondToChangeFolderOwnerMutation>;
export type RespondToChangeFolderOwnerMutationResult = ApolloReactCommon.MutationResult<RespondToChangeFolderOwnerMutation>;
export type RespondToChangeFolderOwnerMutationOptions = ApolloReactCommon.BaseMutationOptions<RespondToChangeFolderOwnerMutation, RespondToChangeFolderOwnerMutationVariables>;
export const RespondToFolderShareDocument = gql`
    mutation RespondToFolderShare($requestId: Int!, $isAccept: Boolean!) {
  respondToFolderShare(requestId: $requestId, isAccept: $isAccept)
}
    `;
export type RespondToFolderShareMutationFn = ApolloReactCommon.MutationFunction<RespondToFolderShareMutation, RespondToFolderShareMutationVariables>;

/**
 * __useRespondToFolderShareMutation__
 *
 * To run a mutation, you first call `useRespondToFolderShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToFolderShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToFolderShareMutation, { data, loading, error }] = useRespondToFolderShareMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      isAccept: // value for 'isAccept'
 *   },
 * });
 */
export function useRespondToFolderShareMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RespondToFolderShareMutation, RespondToFolderShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RespondToFolderShareMutation, RespondToFolderShareMutationVariables>(RespondToFolderShareDocument, options);
      }
export type RespondToFolderShareMutationHookResult = ReturnType<typeof useRespondToFolderShareMutation>;
export type RespondToFolderShareMutationResult = ApolloReactCommon.MutationResult<RespondToFolderShareMutation>;
export type RespondToFolderShareMutationOptions = ApolloReactCommon.BaseMutationOptions<RespondToFolderShareMutation, RespondToFolderShareMutationVariables>;
export const DownloadFolderQrZipDocument = gql`
    mutation DownloadFolderQrZip($folderId: Int!, $extension: String!, $size: Int!) {
  downloadFolderQrZip(folderId: $folderId, extension: $extension, size: $size) {
    status
    url
  }
}
    `;
export type DownloadFolderQrZipMutationFn = ApolloReactCommon.MutationFunction<DownloadFolderQrZipMutation, DownloadFolderQrZipMutationVariables>;

/**
 * __useDownloadFolderQrZipMutation__
 *
 * To run a mutation, you first call `useDownloadFolderQrZipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadFolderQrZipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadFolderQrZipMutation, { data, loading, error }] = useDownloadFolderQrZipMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      extension: // value for 'extension'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useDownloadFolderQrZipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DownloadFolderQrZipMutation, DownloadFolderQrZipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DownloadFolderQrZipMutation, DownloadFolderQrZipMutationVariables>(DownloadFolderQrZipDocument, options);
      }
export type DownloadFolderQrZipMutationHookResult = ReturnType<typeof useDownloadFolderQrZipMutation>;
export type DownloadFolderQrZipMutationResult = ApolloReactCommon.MutationResult<DownloadFolderQrZipMutation>;
export type DownloadFolderQrZipMutationOptions = ApolloReactCommon.BaseMutationOptions<DownloadFolderQrZipMutation, DownloadFolderQrZipMutationVariables>;
export const FolderZipReportDocument = gql`
    query FolderZipReport($folderId: Int!) {
  folderZipReport(folderId: $folderId) {
    status
    url
    extension
    size
  }
}
    `;

/**
 * __useFolderZipReportQuery__
 *
 * To run a query within a React component, call `useFolderZipReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderZipReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderZipReportQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useFolderZipReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FolderZipReportQuery, FolderZipReportQueryVariables> & ({ variables: FolderZipReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FolderZipReportQuery, FolderZipReportQueryVariables>(FolderZipReportDocument, options);
      }
export function useFolderZipReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FolderZipReportQuery, FolderZipReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FolderZipReportQuery, FolderZipReportQueryVariables>(FolderZipReportDocument, options);
        }
// @ts-ignore
export function useFolderZipReportSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FolderZipReportQuery, FolderZipReportQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FolderZipReportQuery, FolderZipReportQueryVariables>;
export function useFolderZipReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FolderZipReportQuery, FolderZipReportQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FolderZipReportQuery | undefined, FolderZipReportQueryVariables>;
export function useFolderZipReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FolderZipReportQuery, FolderZipReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FolderZipReportQuery, FolderZipReportQueryVariables>(FolderZipReportDocument, options);
        }
export type FolderZipReportQueryHookResult = ReturnType<typeof useFolderZipReportQuery>;
export type FolderZipReportLazyQueryHookResult = ReturnType<typeof useFolderZipReportLazyQuery>;
export type FolderZipReportSuspenseQueryHookResult = ReturnType<typeof useFolderZipReportSuspenseQuery>;
export type FolderZipReportQueryResult = ApolloReactCommon.QueryResult<FolderZipReportQuery, FolderZipReportQueryVariables>;
export const GenerateOrGetFolderReportDocument = gql`
    mutation GenerateOrGetFolderReport($folderId: Int!) {
  generateOrGetFolderReport(folderId: $folderId) {
    status
    reportKey
    downloadUrl
    message
  }
}
    `;
export type GenerateOrGetFolderReportMutationFn = ApolloReactCommon.MutationFunction<GenerateOrGetFolderReportMutation, GenerateOrGetFolderReportMutationVariables>;

/**
 * __useGenerateOrGetFolderReportMutation__
 *
 * To run a mutation, you first call `useGenerateOrGetFolderReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOrGetFolderReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOrGetFolderReportMutation, { data, loading, error }] = useGenerateOrGetFolderReportMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useGenerateOrGetFolderReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateOrGetFolderReportMutation, GenerateOrGetFolderReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateOrGetFolderReportMutation, GenerateOrGetFolderReportMutationVariables>(GenerateOrGetFolderReportDocument, options);
      }
export type GenerateOrGetFolderReportMutationHookResult = ReturnType<typeof useGenerateOrGetFolderReportMutation>;
export type GenerateOrGetFolderReportMutationResult = ApolloReactCommon.MutationResult<GenerateOrGetFolderReportMutation>;
export type GenerateOrGetFolderReportMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateOrGetFolderReportMutation, GenerateOrGetFolderReportMutationVariables>;
export const RevokePermissionDocument = gql`
    mutation RevokePermission($id: Int!, $status: GqlShareFolderStatus!) {
  revokePermission(id: $id, status: $status)
}
    `;
export type RevokePermissionMutationFn = ApolloReactCommon.MutationFunction<RevokePermissionMutation, RevokePermissionMutationVariables>;

/**
 * __useRevokePermissionMutation__
 *
 * To run a mutation, you first call `useRevokePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokePermissionMutation, { data, loading, error }] = useRevokePermissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useRevokePermissionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RevokePermissionMutation, RevokePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RevokePermissionMutation, RevokePermissionMutationVariables>(RevokePermissionDocument, options);
      }
export type RevokePermissionMutationHookResult = ReturnType<typeof useRevokePermissionMutation>;
export type RevokePermissionMutationResult = ApolloReactCommon.MutationResult<RevokePermissionMutation>;
export type RevokePermissionMutationOptions = ApolloReactCommon.BaseMutationOptions<RevokePermissionMutation, RevokePermissionMutationVariables>;
export const MarkFolderReportDownloadedDocument = gql`
    mutation MarkFolderReportDownloaded($folderId: Int!) {
  markFolderReportDownloaded(folderId: $folderId)
}
    `;
export type MarkFolderReportDownloadedMutationFn = ApolloReactCommon.MutationFunction<MarkFolderReportDownloadedMutation, MarkFolderReportDownloadedMutationVariables>;

/**
 * __useMarkFolderReportDownloadedMutation__
 *
 * To run a mutation, you first call `useMarkFolderReportDownloadedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFolderReportDownloadedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFolderReportDownloadedMutation, { data, loading, error }] = useMarkFolderReportDownloadedMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useMarkFolderReportDownloadedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkFolderReportDownloadedMutation, MarkFolderReportDownloadedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkFolderReportDownloadedMutation, MarkFolderReportDownloadedMutationVariables>(MarkFolderReportDownloadedDocument, options);
      }
export type MarkFolderReportDownloadedMutationHookResult = ReturnType<typeof useMarkFolderReportDownloadedMutation>;
export type MarkFolderReportDownloadedMutationResult = ApolloReactCommon.MutationResult<MarkFolderReportDownloadedMutation>;
export type MarkFolderReportDownloadedMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkFolderReportDownloadedMutation, MarkFolderReportDownloadedMutationVariables>;